"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A972))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRChevronDown = createSVGIcon(
  <path
    d="m3 8 9 8 9-8"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRChevronDown",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
